import axios from 'axios';

export const TYPOGRAPHY = 'lms/course-typefaces';

export function getTypography() {
  return axios.get(TYPOGRAPHY);
}
